import $ from 'jquery';
import 'owl.carousel';

class HscPartnersCarousel {
  constructor() {
    this.hscCarousel = $('.js-hsc-partners');
    this.slideInterval = 5000;
    this.pauseOnHover = true;
    this.transitionTime = 500;

    this.initCarousel();
  }

  // eslint-disable-next-line class-methods-use-this
  timestamp() {
    return new Date().getTime();
  }

  setAnimationOut() {
    this.t = setTimeout(() => {
      this.page.stop().animate({ opacity: 0 }, this.transitionTime);
    }, this.timeout);
  }

  setAnimationIn() {
    this.page.stop().animate({ opacity: 1 }, this.transitionTime);
  }

  initCarousel() {
    if (!this.hscCarousel.length) {
      return;
    }

    this.hscCarousel.each((i, el) => {
      const hscCarousel = $(el);
      this.time = 0;
      this.timeout = this.slideInterval - this.transitionTime;
      this.paused = false;
      const pages = hscCarousel.find('.js-hsc-partners-page').length;
      const isAnimationEnabled = pages > 1;

      hscCarousel.on('initialized.owl.carousel', e => {
        this.time = this.timestamp();
        const active = hscCarousel.find('.owl-item').eq(e.item.index);
        this.page = active.find('.js-hsc-partners-page');
        this.page.css({ opacity: 1 });

        if (isAnimationEnabled) {
          this.setAnimationOut();
        }
      });

      hscCarousel.owlCarousel({
        items: 1,
        dots: false,
        nav: false,
        animateIn: 'fadeIn',
        mouseDrag: false,
        touchDrag: false,
        autoplaySpeed: 100,
        loop: true,
        autoplay: true,
        autoplayTimeout: this.slideInterval,
        autoplayHoverPause: this.pauseOnHover,
      });

      hscCarousel.on('mouseover.owl.autoplay', () => {
        if (!this.paused && isAnimationEnabled) {
          this.time = this.timestamp() - this.time;
          clearTimeout(this.t);
          this.paused = true;
        }
      });

      hscCarousel.on('mouseleave.owl.autoplay', () => {
        if (this.paused && isAnimationEnabled) {
          this.paused = false;
          const timeout = this.slideInterval - this.time - this.transitionTime;
          this.timeout = timeout < 0 ? 0 : timeout;
          this.setAnimationOut();
        }
      });

      hscCarousel.on('changed.owl.carousel', e => {
        if (isAnimationEnabled) {
          clearTimeout(this.t);
          this.time = this.timestamp();
          this.timeout = this.slideInterval - this.transitionTime;
          const active = hscCarousel.find('.owl-item').eq(e.item.index);
          this.page = active.find('.js-hsc-partners-page');

          hscCarousel
            .find('.owl-item .js-hsc-partners-page')
            .css({ opacity: 0 });
          this.setAnimationIn();
          this.setAnimationOut();
        }
      });
    });
  }
}

export default new HscPartnersCarousel();



// WEBPACK FOOTER //
// ./src/scripts/modules/hsc-partners-carousel.js